import { CSSObject } from '@emotion/react'
import {
  Color,
  FontWeight,
  Size,
  Spacing,
  Typography,
  wideGamutColor,
} from '@opallabs/gem'

export const emptyCategoryContainer: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  height: '40px',
  justifyContent: 'center',
  width: '100%',
}

export const emptyCategoryPill: CSSObject = {
  alignItems: 'center',
  border: '1px solid rgba(151, 151, 151, 0.3)',
  borderRadius: 4,
  color: 'rgba(87, 100, 115, 0.55)',
  display: 'inline-flex',
  fontSize: 11,
  fontWeight: 600,
  justifyContent: 'center',
  lineHeight: 1,
  paddingBlock: 6,
  paddingInline: 12,
  pointerEvents: 'none',
}

export const emptyCategoryText: CSSObject = {
  border: '1px solid rgba(151, 151, 151, .5)',
  color: wideGamutColor(Color.light.Text.Gray, 0.5),
  ...Typography.T500,
  borderRadius: Size.Rounding / 2,
  boxSizing: 'border-box',
  fill: 'currentColor',
  fontSize: 11,
  fontWeight: FontWeight.Bold,
  lineHeight: '22px',
  minInlineSize: 104,
  paddingInline: Spacing.L,
  paddingBlock: Spacing.S,
  position: 'relative',
  textAlign: 'center',
}

export const addCardWrapper: CSSObject = {
  height: 84,
}
